import actions from "~/shared/actions/bankAccounts";
import * as server from "~/shared/api/server";

export function getBankAccounts() {
	return (dispatch) => {
		dispatch(actions.bankAccountsRequest());
		return server.getBankAccounts().then((json) => dispatch(actions.bankAccountsResponse(json)));
	};
}
